import type { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Link,
  Typography,
} from '@mui/material';
import { getRegisterState, State as RegisterState } from '@/reducers/register';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import LayoutPlain from './LayoutPlain';

const Register: FC = () => {
  const registerState: RegisterState = useSelector(getRegisterState)
  const dispatch = useDispatch()
  if (registerState.processing || !registerState.success || !registerState.email) {
    // these are all unexpected states, potentially illegal entrance;
    // we'll redirect to root, where authorzation is enforced
    dispatch(push('/'))
  }

  return (
    <LayoutPlain>
      <Helmet>
        <title>Register | OnData</title>
      </Helmet>
      <Typography
        color="textPrimary"
        sx={{ fontWeight: 'fontWeightBold', mt: 5 }}
        variant="h2"
      >
        Account Activation
      </Typography>
      <Typography
        sx={{ color: 'primary.main', py: 3 }}
        variant="h6"
      >
        Thank you for registering an account with OnData!
      </Typography>
      <Typography
        color="textPrimary"
        variant="body1"
      >
        Your registration is pending review by the OnData Customer Success team. 
        We may contact you for further account verification. Once your account
        {' '}
        <Link
          color="primary"
          underline="hover"
          variant="body2"
        >
          [{registerState.email}]
        </Link>
        {' '}
        is approved by OnData, 
        you will receive an email from OnData to complete the remaining registration process. 
        We appreciate your business and look forward to taking your data to next level of security and performance!
      </Typography>
    </LayoutPlain>
  );
};

export default Register;
